<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 262.2 177.81" style="enable-background:new 0 0 262.2 177.81;" xml:space="preserve">
    <g>
        <circle :style="defineStroke" class="st0" cx="89.58" cy="88.99" r="83.16"/>
        <circle :style="defineStroke" class="st1" cx="89.58" cy="88.99" r="67.45"/>
        <polyline :style="defineStroke" class="st0" points="125.11,13.79 255.58,13.79 255.58,40.54 156.08,40.54 	"/>
        <polyline :style="defineStroke" class="st0" points="118.7,167.29 255.58,167.29 255.58,40.54 	"/>
        <rect x="204.74" y="66.25" :style="defineStroke" class="st1" width="28.96" height="28.96"/>
        <rect x="204.74" y="113.16" :style="defineStroke" class="st1" width="28.96" height="28.96"/>
        <polyline :style="defineStroke" class="st1" points="169.11,66.25 187.86,66.25 187.86,95.21 172.51,95.21 	"/>
        <polyline :style="defineStroke" class="st1" points="169.17,113.16 187.86,113.16 187.86,142.12 154.74,142.12 	"/>
        <path :style="defineStroke" class="st0" d="M49.11,114.81c23.2-23.2,60.82-23.2,84.02,0"/>
        <circle :style="defineFill" class="st2" cx="53.77" cy="77.51" r="6.78"/>
        <circle :style="defineFill" class="st2" cx="125.48" cy="77.51" r="6.78"/>
    </g>
</svg>
</template>
<script>
export default {
    data:() => ({colors: ''}),
    props:{
        status: {
            require: false,
            type: String
        }
    },
    created(){
        // console.log("STATUS: ", this.status)
        this.colors = JSON.parse(localStorage.getItem('colors'))
    },
    computed:{
        defineStroke(){
            if(this.colors.theme == 'dark') return {'stroke': '#000'}
            return {'stroke': "#000"}
        },
        defineFill(){
            if(this.colors.theme == 'dark') return {'fill': '#000'}
            return {'fill': "#000"}
        },
    }    
}

</script>
<style type="scss" scoped>
	.st0{fill:none;stroke-width:7;stroke-miterlimit:10;}
	.st1{fill:none;stroke-width:6;stroke-miterlimit:10;}
</style>
